// Compare the existing session's JWT id locally. This is not authentication or
// signature validation; authorization still belongs to the existing backend.
// Never pass this value to analytics events, storage or Google User-ID.
export function sessionIdentity(token) {
  if(!token)return null;
  try {
    const encoded=token.split('.')[1].replace(/-/g,'+').replace(/_/g,'/');
    const payload=JSON.parse(atob(encoded));
    const id=Number(payload.id);
    return Number.isSafeInteger(id)&&id>0?String(id):null;
  } catch {return null;}
}
export function sameAccount(previous,next) {
  const before=sessionIdentity(previous),after=sessionIdentity(next);
  return !!previous&&!!next&&before!==null&&before===after;
}

// Consent UI lifecycle only. This does not validate or change authentication.
export function sessionExpiry(token) {
  try {
    const payload=JSON.parse(atob(token.split('.')[1].replace(/-/g,'+').replace(/_/g,'/')));
    return typeof payload.exp==='number'&&Number.isFinite(payload.exp)&&payload.exp>0?payload.exp*1000:null;
  } catch {return null;}
}
export function watchSessionExpiry(token,onExpire) {
  const expiry=sessionExpiry(token);let timer;
  if(expiry===null)return ()=>{};
  const arm=()=>{const remaining=expiry-Date.now();
    if(remaining<=0){onExpire();return;}
    timer=setTimeout(arm,Math.min(remaining,2147483647));
  };
  arm();return()=>clearTimeout(timer);
}
